'use strict';

export default class Loading extends React.Component {
    render() {
        const {active, text = null, absolute = true, styleContainer = {}, style = {}} = this.props;
        const className = text !== null || absolute === false ? 'preloader' : 'loaderContainer';
        if(!active) return null;
        return <div className={className} style={styleContainer}>
            <div className="loader" style={style}></div>
            {text !== null && <span className="loader-text">
                {text}
            </span>}
        </div>
    }
}
